import { Paper, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { formatDateTime } from "../../utils/DateTimeUtils";
import { CustomTableRowTR, StyledTable, TableData, TableHeader, TableWrapper } from "../../styles/commonStyles";

const CustomerCallRecordingsTable = (props: any) => {

    return (
        <TableWrapper>
            <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
                <StyledTable>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3) !important" }}>
                            <TableHeader>Id</TableHeader>
                            <TableHeader>Virtual Number</TableHeader>
                            <TableHeader>Initiated By</TableHeader>
                            <TableHeader>Call Date and Time</TableHeader>
                            <TableHeader>Duration (in Sec)</TableHeader>
                            <TableHeader>Recording</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            props?.data?.map((recordings: any) => (
                                recordings && recordings?.recordingUrls?.map((recording: any,i:number) => (
                                    <CustomTableRowTR key={i}>
                                        <TableData>{i+1}</TableData>
                                        <TableData>{recordings?.virtualNumber}</TableData>
                                        <TableData>{recording?.initiatedBy}</TableData>
                                        <TableData>{formatDateTime(recording?.callTime) || "-"}</TableData>
                                        <TableData>
                                            {
                                                Math.floor((recording?.onCallDuration) / 60) !== 0 ?
                                                    Math.floor((recording?.onCallDuration) / 60) + " min " + ((recording?.onCallDuration) % 60)+" sec" :
                                                    ((recording?.onCallDuration) % 60)+" sec"
                                            }
                                        </TableData>
                                        <TableData>
                                            <audio src={recording.url} controls></audio>
                                        </TableData>
                                    </CustomTableRowTR>
                                ))
                            ))
                        }
                    </TableBody>
                </StyledTable>
            </TableContainer>
        </TableWrapper>
    )
}
export default CustomerCallRecordingsTable;
